import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import {
  getComandas,
  deleteComanda,
  putComanda,
} from "../helpers/rutaComandas";
import Table from "./TableContainer";
import ModalFormComanda from "../components/ModalFormComanda";
import ModalPagosComanda from "../components/ModalPagosComanda";
import { generarPDFComanda } from "../helpers/pdfComandas";
import ModalOrdenCobro from "../components/ModalOrdenCobro";
import { generarPDFOrdenCobroPorNro } from "../helpers/pdfOrdenCobro";
import { getOrdenCobroByNro } from "../helpers/rutaOrdenesCobro";
import ModalVerOrdenCobro from "../components/ModalVerOrdenCobro";
import ModalSaldoCliente from "../components/ModalSaldoCliente";


// >>> NUEVO: OP
import ModalOrdenPago from "../components/ModalOrdenPago";
import { generarPDFOrdenPago } from "../helpers/pdfOrdenPago";

import "../css/tablecomandas.css";

const Styles = styled.div`
  .table-container { overflow: auto; height: 600px; }
  table { border: 1px solid black; border-spacing: 0; font-size: 13px; }
  th, td { padding: 0.5rem; border-bottom: 1px solid black; border-right: 1px solid black; }
  th { background-color: #778899; position: sticky; top: 0; z-index: 2; text-align: center; font-size: 12px; }
  td { background-color: white; }
  .pagination { padding: 0.5rem; background-color: #778899; font-size: 15px; font-weight: bold; }
`;

export default function AppComandaReactTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [comandaSel, setComandaSel] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);

  const [showModalPago, setShowModalPago] = useState(false);
  const [idComandaPago, setIdComandaPago] = useState(null);

  // OC
  const [showModalOC, setShowModalOC] = useState(false);
  const [clienteOC, setClienteOC] = useState(null);
  const [preseleccionOC, setPreseleccionOC] = useState([]);

  const [showVerOC, setShowVerOC] = useState(false);
  const [verOcId, setVerOcId] = useState(null);

  // >>> NUEVO: OP
  const [showModalOP, setShowModalOP] = useState(false);
  const [terceroOP, setTerceroOP] = useState(null);        // codtra
  const [clienteOP, setClienteOP] = useState(null);        // filtro opcional
  const [preseleccionOP, setPreseleccionOP] = useState([]);// [{_id,codcom,nroviaje,fecha,factura,pactado,pagado,saldo}]

  const [showSaldoCliente, setShowSaldoCliente] = useState(false);

  const fmtARS = (n) => (Number(n || 0)).toLocaleString("es-AR", { style: "currency", currency: "ARS" });

  const fetchData = useCallback(async () => {
    const resp = await getComandas();
    if (!resp?.ok) {
      console.error(resp?.error || "Error al obtener comandas");
      setData([]);
    } else {
      setData(resp.comandas || []);
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleCloseEdit = () => { setShowModalEdit(false); fetchData(); };
  const handleClosePago = () => { setShowModalPago(false); setIdComandaPago(null); fetchData(); };

  const borrar = useCallback(async (id) => {
    if (!window.confirm("¿Eliminar comanda?")) return;
    await deleteComanda(id);
    fetchData();
  }, [fetchData]);

  const editar = useCallback(async (id, values) => {
    await putComanda(id, values);
    fetchData();
  }, [fetchData]);

  // ---------- OC ----------
  const openOCFromRow = (row) => {
    const cli = row.original.codclif || row.original.codclic || row.original.codclid;
    if (!cli?._id) return alert("La comanda no tiene cliente asociado.");

    setClienteOC(cli);

    const total = Number(row.original.total || 0);
    const totalPagado = Number(row.original.totalPagado || 0);
    const saldo = total - totalPagado;

    const pre = saldo > 0.01 ? [{
      _id: row.original._id,
      codcom: row.original.codcom,
      nroviaje: row.original.nroviaje,
      fecha: row.original.fecha,
      saldo: Number(saldo.toFixed(2)),
      total: Number(total.toFixed(2)),
    }] : [];

    setPreseleccionOC(pre);
    setShowModalOC(true);
  };

  const closeOC = (refrescar) => {
    setShowModalOC(false);
    setClienteOC(null);
    setPreseleccionOC([]);
    if (refrescar) fetchData();
  };

  // ---------- OP (nuevo) ----------
  const openOPFromRow = (row) => {
    const tercero = row.original.codtra;
    if (!tercero?._id) return alert("La comanda no tiene 'Transporte' (tercero) asociado.");

    setTerceroOP(tercero);

    // cliente como filtro opcional (igual que OC)
    const cli = row.original.codclif || row.original.codclic || row.original.codclid;
    setClienteOP(cli?._id ? cli : null);

    const pactado = Number(row.original.pactadoter || 0);
    const pagadoTercero = Number(row.original.pagadoTercero || 0);
    const saldo = pactado - pagadoTercero;

    const pre = saldo > 0.01 ? [{
      _id: row.original._id,
      codcom: row.original.codcom,
      nroviaje: row.original.nroviaje,
      fecha: row.original.fecha,
      factura: row.original.factura,
      pactado,
      pagado: pagadoTercero,
      saldo: Number(saldo.toFixed(2)),
    }] : [];

    setPreseleccionOP(pre);
    setShowModalOP(true);
  };

  const closeOP = (refrescar) => {
    setShowModalOP(false);
    setTerceroOP(null);
    setClienteOP(null);
    setPreseleccionOP([]);
    if (refrescar) fetchData();
  };

  const columns = useMemo(() => [
    {
      id: "editar",
      Header: "Edita",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--edit"
          title="Editar comanda"
          onClick={() => { setComandaSel(row.original); setShowModalEdit(true); }}
        >
          <i className="fa fa-pencil" aria-hidden="true" />
        </button>
      ),
    },
    {
      id: "pagar",
      Header: "Paga",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--pay"
          title="Registrar pagos"
          onClick={() => { setIdComandaPago(row.original._id); setShowModalPago(true); }}
        >
          <i className="fa fa-money" aria-hidden="true" />
        </button>
      ),
    },
    {
      id: "pdf",
      Header: "PDF",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--pdf"
          title="Descargar PDF"
          onClick={() => generarPDFComanda(row.original._id)}
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" />
        </button>
      ),
    },

    // --------- OC (ya lo tenías) ---------
    {
      id: "ordenCobro",
      Header: "OC",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--oc"
          title="Orden de Cobro"
          onClick={() => openOCFromRow(row)}
        >
          <i className="fa fa-credit-card" aria-hidden="true" />
        </button>
      ),
    },

    // --------- OP (nuevo, va justo después del de OC) ---------
    {
      id: "ordenPago",
      Header: "OP",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          className="action-btn action-btn--op"
          title="Orden de Pago a tercero"
          onClick={() => openOPFromRow(row)}
        >
          <i className="fa fa-bank" aria-hidden="true" />
        </button>
      ),
    },

    

    { Header: "Cod", accessor: "codcom", width: 70 },
    { Header: "Nro Viaje", accessor: "nroviaje", width: 90 },
    { Header: "Empresa", accessor: "codemp.empresa", width: 160 },

    {
      Header: "Fecha",
      accessor: r => (r.fecha ? new Date(r.fecha) : ""),
      id: "fecha",
      width: 120,
      Cell: ({ value }) => value instanceof Date ? value.toLocaleDateString("es-AR") : "-",
    },

    { Header: "Transporte", accessor: "codtra.transporte", width: 160 },
    { Header: "Chofer", accessor: "codcho.nombre", width: 250 },
    { Header: "Cliente Factura", accessor: "codclif.razonsocial", width: 220 },
    { Header: "Cliente Carga", accessor: "codclic.razonsocial", width: 220 },
    { Header: "Cliente Descarga", accessor: "codclid.razonsocial", width: 220 },
    { Header: "Origen", accessor: "codori.destino", width: 180 },
    { Header: "Destino", accessor: "coddes.destino", width: 180 },
    { Header: "Factura", accessor: "factura", width: 200 },
    { Header: "Estado", accessor: "estado", width: 200 },
    { Header: "Nro Remito", accessor: "remitos", width: 140 },
    { Header: "Producto", accessor: "codpro.producto", width: 160 },
    { Header: "Camión", accessor: "codcam.camion", width: 160 },
    { Header: "Estado/Situacion", accessor: "codest.estado", width: 120 },

    {
      Header: "Kg Sal",
      accessor: "kgsal",
      id: "kgsal",
      width: 90,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value?.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.kgsal || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'blue'}}>{total.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>;
      },
    },
    {
      Header: "Kg Lle",
      accessor: "kglle",
      id: "kglle",
      width: 90,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value?.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.kglle || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'blue'}}>{total.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>;
      },
    },
    {
      Header: "Dif",
      accessor: "dif",
      id: "dif",
      width: 90,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value?.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.dif || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'blue'}}>{total.toLocaleString('es-AR',{minimumFractionDigits:2,maximumFractionDigits:2})}</div>;
      },
    },

    {
      Header: "Pactado",
      accessor: "pactado",
      id: "pactado",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.pactado || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'red'}}>{fmtARS(total)}</div>;
      },
    },
    {
      Header: "Sub Total",
      accessor: "subtotal",
      id: "subtotal",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.subtotal || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'red'}}>{fmtARS(total)}</div>;
      },
    },
    {
      Header: "IVA",
      accessor: "iva",
      id: "iva",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.iva || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'red'}}>{fmtARS(total)}</div>;
      },
    },
    {
      Header: "Total",
      accessor: "total",
      id: "total",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.total || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'red'}}>{fmtARS(total)}</div>;
      },
    },
    {
      Header: "Pactado Ter",
      accessor: "pactadoter",
      id: "pactadoter",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.pactadoter || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'red'}}>{fmtARS(total)}</div>;
      },
    },

    { Header: "Km Ori", accessor: "kmsal", width: 90 },
    { Header: "Km Des", accessor: "kmdes", width: 90 },
    { Header: "Observaciones", accessor: "observ", width: 200 },

    {
      Header: "Pagado",
      accessor: r => r.totalPagado ?? 0,
      id: "totalPagado",
      width: 120,
      Cell: ({ value }) => <div style={{textAlign:'right'}}>{value ? fmtARS(value) : ""}</div>,
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.totalPagado || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color:'green'}}>{fmtARS(total)}</div>;
      },
    },
    {
      Header: "Saldo",
      accessor: r => r.saldoPendiente ?? ((r.total || 0) - (r.totalPagado || 0)),
      id: "saldoPendiente",
      width: 120,
      Cell: ({ value }) => (
        <div style={{textAlign:'right', color: Number(value) < 0 ? 'red' : 'inherit'}}>
          {fmtARS(value)}
        </div>
      ),
      Footer: ({ rows }) => {
        const total = rows.reduce((s, r) => s + (r.values.saldoPendiente || 0), 0);
        return <div style={{textAlign:'right',fontWeight:'bold',color: total < 0 ? 'red' : 'blue'}}>{fmtARS(total)}</div>;
      },
    },
  ], [borrar]);

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-4">LISTADO DE COMANDAS</h3>

      {/* Toolbar superior */}
      <div className="mb-3" style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {/* ---- OC ---- */}
        <button
          className="btn btn-outline-primary btn-sm"
          style={{ fontSize: 14, padding: '8px 12px' }}
          onClick={() => {
            const id = prompt("Pegá el _id de la Orden de Cobro:");
            if (id) { setVerOcId(id); setShowVerOC(true); }
          }}
        >
          Ver/Editar OC por ID
        </button>

        <button
          className="btn btn-outline-secondary btn-sm"
          style={{ fontSize: 14, padding: '8px 12px' }}
          onClick={async () => {
            const nro = prompt("N° de orden del cliente (ej: 000123):");
            if (!nro) return;
            const res = await getOrdenCobroByNro(nro);
            if (res?.ok) {
              setVerOcId(res.ordenCobro._id);
              setShowVerOC(true);
            } else {
              alert(res?.msg || "No se encontró la Orden de Cobro.");
            }
          }}
        >
          Ver/Editar OC por N°
        </button>

        <button
          className="btn btn-outline-success btn-sm"
          style={{ fontSize: 14, padding: '8px 12px' }}
          onClick={async () => {
            const nro = prompt("N° de orden del cliente a imprimir:");
            if (!nro) return;
            await generarPDFOrdenCobroPorNro(nro);
          }}
        >
          Imprimir OC por N°
        </button>

        {/* ---- OP (nuevo) ---- */}
        <button
          className="btn btn-outline-dark btn-sm"
          style={{ fontSize: 14, padding: '8px 12px' }}
          onClick={async () => {
            const id = prompt("Pegá el _id de la Orden de Pago:");
            if (!id) return;
            await generarPDFOrdenPago(id); // el helper busca por id y arma el PDF
          }}
        >
          Imprimir OP por ID
        </button>

        {/* <button
          className="btn btn-outline-dark btn-sm"
          style={{ fontSize: 14, padding: '8px 12px', minWidth: 160, whiteSpace: 'nowrap' }}
          onClick={() => setShowSaldoCliente(true)}
        >
          Saldo x Cliente (PDF)
        </button> */}

      </div>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={data}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
          />
        </div>
      </Styles>

      {showModalEdit && (
        <ModalFormComanda
          show={showModalEdit}
          handleClose={handleCloseEdit}
          comanda={comandaSel}
          onSave={editar}
        />
      )}

      <ModalPagosComanda
        show={showModalPago}
        onClose={handleClosePago}
        idComanda={idComandaPago}
      />

      {showModalOC && clienteOC && (
        <ModalOrdenCobro
          show={showModalOC}
          onHide={closeOC}
          cliente={clienteOC}
          comandasPreseleccionadas={preseleccionOC}
        />
      )}

      {/* ---- OP Modal (nuevo) ---- */}
      {showModalOP && terceroOP && (
        <ModalOrdenPago
          show={showModalOP}
          onHide={closeOP}
          tercero={terceroOP}
          cliente={clienteOP}
          comandasPreseleccionadas={preseleccionOP}
        />
      )}

      {showVerOC && (
        <ModalVerOrdenCobro
          show={showVerOC}
          onHide={(refrescar) => {
            setShowVerOC(false);
            setVerOcId(null);
            if (refrescar) fetchData();
          }}
          ocId={verOcId}
        />
      )}

      {showSaldoCliente && (
        <ModalSaldoCliente
          show={showSaldoCliente}
          onHide={() => setShowSaldoCliente(false)}
        />
      )}

    </div>
  );
}
